/**
 * Posts carousel
 */

var elenia_carousel_init = function(instance) {
  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 24,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
  };

  var elenia_carousel = function() {
    var carousel = document.querySelectorAll('.js-carousel');

    for (var i = 0; i < carousel.length; i++) {
      elenia_carousel_init(carousel[i]);
    }
  };

  elenia_carousel();